import { render, staticRenderFns } from "./usersMsg.vue?vue&type=template&id=39e2fd16&scoped=true"
import script from "./usersMsg.vue?vue&type=script&lang=js"
export * from "./usersMsg.vue?vue&type=script&lang=js"
import style0 from "./usersMsg.vue?vue&type=style&index=0&id=39e2fd16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e2fd16",
  null
  
)

export default component.exports